import React, { Component} from 'react';
import { Button, Form } from 'react-bootstrap';
import Auth from '../../Auth/Auth';
import Compressor from 'compressorjs';
import IsLoadingBar from '../isLoading';

import './Cuteness.scss';
import moment from 'moment';


const auth = new Auth();

function parseJwt (token) {
  
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

function getPrevWeekday(getDate){
    let prevWeekday;
    if(moment(getDate).day() === 1){
        prevWeekday = moment(getDate).subtract(3,'days').format("YYYY-MM-DD");
    } else if(moment(getDate).day() === 7) {
        prevWeekday = moment(getDate).subtract(2,'days').format("YYYY-MM-DD");
    } else {
        prevWeekday = moment(getDate).subtract(1,'days').format("YYYY-MM-DD");
    }
    return prevWeekday;
}

export default class Cuteness extends Component {
    constructor(props){
      super(props);

      this.state = {
        isSubmit: false,
        isuploading: false,
        isLoading : true,
        cuteness: [],
        getDate : moment().format("YYYY-MM-DD")
      };
    }

    async componentDidMount(){  
        let accessToken = await auth.getToken();
        fetch(`/api/usercuteness`,{
            method : "GET",
            headers : {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                cutenessdate: this.state.getDate
            }
        }).then(response => {
            if(response.status!==200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(success => {
            if(success){
                this.setState({
                    cuteness : success,
                    isLoading : false,
                });
            }            
        }).catch((error) => {
            console.error('Error:', error);
            window.apiError(error);
        });
    }

    async getCuteness(){  
        this.setState({
            getDate: getPrevWeekday(this.state.getDate),
            isLoading : true,
        });
        let accessToken = await auth.getToken();
        fetch(`/api/usercuteness`,{
            method : "GET",
            headers : {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                cutenessdate: this.state.getDate
            }
        }).then(response => {
            if(response.status!==200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(success => {
            if(success){
                this.setState({
                    cuteness : success,
                    isLoading : false,
                });
            }            
        }).catch((error) => {
            console.error('Error:', error);
            window.apiError(error);
        });
    }

    handleChange(e){
        this.setState({
            [e.target.name] : e.target.value,
        });
    }

    uploadImage(e){
        var self = this;
        var file = e.target.files[0];  
        e.target.value = "";

        if (!file) {
            return;
        }

        //Compress Image down to 0.6 but keep ratio
        new Compressor(file, {
            quality: 0.4,
            success(result) {        
                var reader = new FileReader();
                reader.readAsDataURL(result);
              // Store the Compressed Image in the state
              reader.onload = function(event) {
                let contents = event.target.result;
                let fileName = file.name;
        
                self.setState({
                    cutenessImage : contents,
                    imageName : fileName
                });
            };
        
            reader.onerror = function(event) {
                console.error("File could not be read! Code " + event.target.error.code);
            };
              
            },
            error(err) {
                console.error(err);
            },
          });

        
        

      }

    async submitCuteness(){
        this.setState({
            isuploading: true
        });
    let accessToken = await auth.getToken();
    let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
        
    let cuteness = {
        Name: this.state.Name,
        Breed: this.state.Breed,
        Owner: this.state.Owner,
        Image : this.state.cutenessImage,
        postedBy: jwt.oid
    };

    fetch(`/api/usercuteness`,{
        method : "POST",
        headers : {
            "Content-Type": "application/json",
            'Authorization': "Bearer " + accessToken,
            withCredentials : true,
            crossDomain: true,
        },
        body: JSON.stringify(cuteness)
        }).then(response => {
            if(response.status!==200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }]
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json()
        })
        .then(success => {
            this.setState({
                Name: '',
                Breed: '',
                Owner: '',
                Image : '',
                message : `Thank you for your submission. We will check over the information provided and once approved, your submission will be featured in Dose of Cuteness.`,
                isuploading: false
            })
        }).catch((error) => {
            console.error('Error:', error);
            window.apiError(error);
        });
    }


  render(){
    return (     
        <div id="cuteness" className="p-4 text-muted" >
            {!this.state.isSubmit ?  
                <div id="animal"> 
                    <h1 className="text-center">Dose of Cuteness</h1>
                    {this.state.isLoading && (
                        <IsLoadingBar alttext={"Cuteness is loading"} />  
                    )}
                    {this.state.cuteness.map((items,index) => 
                    <div key={index}>
                        <p>Name: <strong>{items.Name}</strong></p>
                        <p>Breed: <strong>{items.Breed}</strong></p>
                        <p>Family:  <strong>{items.Owner}</strong></p>
                        <img src={items.Image} alt="todays daily cuteness" /> 
                    </div>                            
                        
                    )}                    
                    <div className="mx-auto">        
                        <Button variant="link" className="float-right" onClick={() => this.setState({ isSubmit : true})}>Want your animal featured?</Button>
                    </div> 
                    <Button variant="link" className="float-left p-0 m-0" style={{position: "absolute", bottom: "5px" }} onClick={() => this.getCuteness() }><small>Show previous</small></Button>
                </div>
                :
                <div id="submit">
                    <Form >
                        <Form.Group>
                            <Form.Label>Pet or Animal's Name</Form.Label>
                            <Form.Control name="Name" type="text" placeholder="Name..." onChange={(e) => this.handleChange(e)} value={this.state.Name} autoComplete="off"/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Breed/Type</Form.Label>
                            <Form.Control name="Breed" type="text" placeholder="Breed..." onChange={(e) => this.handleChange(e)} value={this.state.Breed} autoComplete="off" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Family Name</Form.Label>
                            <Form.Control  name="Owner" type="text" placeholder="Family..." onChange={(e) => this.handleChange(e)} value={this.state.Owner} autoComplete="off" />
                        </Form.Group>

                        <Button variant="link" onClick={(e) => this.refs.ImageUpload.click()}><i className="fa fa-camera mr-2" aria-hidden="true"></i>Attach image</Button>
                        <p><small>Make sure the image is rotated correctly</small></p>
                        <input type="file" ref="ImageUpload" onChange={(e) => this.uploadImage(e)} hidden/>
                            {this.state.imageName && (
                                <div>
                                    <img src={this.state.cutenessImage} style={{width: "200px"}} alt="todays daily cuteness" />
                                    <ul>
                                        <li>{this.state.imageName} <Button variant="link" onClick={() => this.setState({ cutenessImage: null ,imageName: null  })}>X</Button></li>
                                    </ul>
                                </div>
                                
                            )} 
                        <Button onClick={() => this.submitCuteness()} disabled={!this.state.Name || !this.state.Breed || !this.state.Owner || !this.state.imageName || this.state.isuploading}>{this.state.isuploading ? "Sending..." : "Send"}</Button>
                        <p><small>NOTE: We track submissions by username for security and policy reasons</small></p>
                        <p className="mt-3" style={{width: "200px", fontSize: "13px"}}>{this.state.message}</p>
                        
                    </Form>
                    
                </div>
            }                                  
        </div> 
    );
  }
}